import { SwipeableDrawer as SwipeableDrawerBase } from "@mui/material";
import { useScroll } from "ahooks";
import clsx from "clsx";
import { useRef } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  disableRestoreFocus?: boolean;
  hasFullHeight?: boolean;
  heightOffset?: number;
  backgroundColor?: string;
  keepMounted?: boolean;
  fixedHeader?: React.ReactNode;
  children: React.ReactNode;
};

export function SwipeableDrawer({
  children,
  hasFullHeight,
  heightOffset = 0,
  backgroundColor,
  keepMounted = false,
  fixedHeader,
  open,
  ...rest
}: Props) {
  const contentWrapperRef = useRef<HTMLDivElement>(null);
  const scroll = useScroll(contentWrapperRef);

  const heightOffsetWithUnit = `${heightOffset}px`;

  const heightStyle = hasFullHeight
    ? `calc(100dvh - ${heightOffsetWithUnit})`
    : "auto";

  return (
    <SwipeableDrawerBase
      anchor="bottom"
      open={open}
      onOpen={() => {}} // required prop, but we don't need to do anything on open
      sx={{
        "& .MuiDrawer-paper": {
          height: heightStyle,
          backgroundColor,
        },
      }}
      ModalProps={{
        keepMounted,
      }}
      {...rest}
    >
      {/* puller */}
      <div className="mx-auto -mt-4 mb-4 h-1 w-10 shrink-0 rounded-full bg-stroke-neutral-soft" />
      {fixedHeader ? (
        <>
          {fixedHeader}
          <div
            ref={contentWrapperRef}
            className={clsx(
              "-mx-main space-y-4 overflow-y-auto border-t-stroke-neutral-soft px-main",
              {
                "border-t": scroll && scroll?.top > 0,
              },
            )}
          >
            {children}
          </div>
        </>
      ) : (
        children
      )}
    </SwipeableDrawerBase>
  );
}
